import { render } from "./CoBrandForge.vue?vue&type=template&id=68af6bdd&scoped=true"
import script from "./CoBrandForge.vue?vue&type=script&lang=js"
export * from "./CoBrandForge.vue?vue&type=script&lang=js"

import "./CoBrandForge.vue?vue&type=style&index=0&id=68af6bdd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68af6bdd"]])

export default __exports__